/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plain_Text_Import_Max_Chars_LabelInputs */

const en_plain_text_import_max_chars_label = /** @type {(inputs: Plain_Text_Import_Max_Chars_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Max Characters Per Line`)
};

const fr_plain_text_import_max_chars_label = /** @type {(inputs: Plain_Text_Import_Max_Chars_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nombre max de caracteres par ligne`)
};

const de_plain_text_import_max_chars_label = /** @type {(inputs: Plain_Text_Import_Max_Chars_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maximale Zeichen pro Zeile`)
};

const it_plain_text_import_max_chars_label = /** @type {(inputs: Plain_Text_Import_Max_Chars_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Numero massimo di caratteri per riga`)
};

const ru_plain_text_import_max_chars_label = /** @type {(inputs: Plain_Text_Import_Max_Chars_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Максимальное количество символов в строке`)
};

const es_plain_text_import_max_chars_label = /** @type {(inputs: Plain_Text_Import_Max_Chars_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Máximo de caracteres por línea`)
};

const zh_cn2_plain_text_import_max_chars_label = /** @type {(inputs: Plain_Text_Import_Max_Chars_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`每行最大字符数`)
};

const ja_plain_text_import_max_chars_label = /** @type {(inputs: Plain_Text_Import_Max_Chars_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1行あたりの最大文字数`)
};

const hi_plain_text_import_max_chars_label = /** @type {(inputs: Plain_Text_Import_Max_Chars_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्रति पंक्ति अधिकतम अक्षर`)
};

const pt_pt2_plain_text_import_max_chars_label = /** @type {(inputs: Plain_Text_Import_Max_Chars_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Número máximo de caracteres por linha`)
};

/**
* | output |
* | --- |
* | "Max Characters Per Line" |
*
* @param {Plain_Text_Import_Max_Chars_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const plain_text_import_max_chars_label = /** @type {((inputs?: Plain_Text_Import_Max_Chars_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plain_Text_Import_Max_Chars_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_plain_text_import_max_chars_label(inputs)
	if (locale === "de") return de_plain_text_import_max_chars_label(inputs)
	if (locale === "it") return it_plain_text_import_max_chars_label(inputs)
	if (locale === "ru") return ru_plain_text_import_max_chars_label(inputs)
	if (locale === "es") return es_plain_text_import_max_chars_label(inputs)
	if (locale === "zh-CN") return zh_cn2_plain_text_import_max_chars_label(inputs)
	if (locale === "ja") return ja_plain_text_import_max_chars_label(inputs)
	if (locale === "hi") return hi_plain_text_import_max_chars_label(inputs)
	if (locale === "pt-PT") return pt_pt2_plain_text_import_max_chars_label(inputs)
	return en_plain_text_import_max_chars_label(inputs)
});